import { useRef } from 'react';
import Card from '@/components/Card';
import { Input } from '@/components/Controls/Input';
import { IconTransfer } from '@tabler/icons-react';
import { notify } from '@/utils/toast.utils';
import { NOTIFY } from '@/utils/constant.utils';
import { TFunction } from 'i18next';

type GroupAPIManagementProps = {
  t: TFunction<undefined>;
  apiToken: string;
};

export const GroupAPIManagement = ({ apiToken, t }: GroupAPIManagementProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(apiToken);
    notify(t('common:tokenCopied'), NOTIFY.INFO);
  };

  return (
    <Card
      title={
        <div className="flex items-center gap-2">
          <IconTransfer className="text-purple-500" stroke={2} size={18} /> API
        </div>
      }
    >
      <div className="flex gap-2">
        <p className="text-md self-center text-primary">{t('groupAPIToken')}</p>
        <Input
          ref={inputRef}
          rightIcon={
            <i
              className="ki-outline ki-copy cursor-pointer hover:text-primary"
              onClick={handleCopy}
            />
          }
          value={apiToken}
          readOnly
        />
      </div>
    </Card>
  );
};